const Alert = {
    success(message, title, action) {
        title = title || 'Succès';
        message = this.normalize(message);
        return window.App.$swal({
            type: 'success',
            title: title,
            html: message,
            useRejections: false
        });
    },

    error(message, title) {
        title = title || 'Erreur';
        message = this.normalize(message);
        return window.App.$swal({
            type: 'error',
            title: title,
            html: message,
            useRejections: false
        });
    },

    yesno(message, title, yes, no, type) {
        type = type || 'question';
        window.App.$swal({
            title: title,
            type: type,
            html: message,
            showCloseButton: false,
            showCancelButton: true,
            confirmButtonText: yes.label,
            cancelButtonText: no.label,
            confirmButtonColor: '#607d8b',
            cancelButtonColor: '#37474f',
        }).then(yes.action).catch(no.action)
    },

    normalize(message) {
        if (typeof message !== 'object') {
            return message;
        }

        if (message.response) {
            let reason = message.response.data.hasOwnProperty('message') ? message.response.data.message : JSON.stringify(message.response.data);

            if (reason) {
                reason = `<p>${reason}</p>`;
            }

            return `<p><strong>Erreur ${message.response.status}</strong></p>${reason}`;
        }

        return `<pre>${JSON.stringify(message)}</pre>`;
    }
};

export default Alert;


// WEBPACK FOOTER //
// ./resources/assets/js/services/alert.js